<template>
  <div class="inline-flex flex-wrap gap-1 rounded-lg bg-black/70 p-1" role="radiogroup" :aria-label="label">
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      class="rounded-sm px-2.5 py-1 text-xs font-medium tracking-[0.01em] transition-[background-color,color] duration-150"
      :class="
        value === option.value
          ? 'bg-[#ffaa00] text-black'
          : 'bg-transparent text-slate-300 hover:text-white'
      "
      @click="$emit('input', option.value)"
    >
      {{ option.label }}
    </button>
  </div>
</template>

<script>
export default {
  name: "PillSelector",
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    label: {
      type: String,
      default: "Options",
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
